(function () {
  var root = document.querySelector('[data-tex-partner-bar]');
  if (!root) return;
  var key = 'tex-partner-bar-dismiss';
  try {
    window.localStorage.removeItem(key);
  } catch (error) {}
  try {
    if (window.sessionStorage.getItem(key) === '1') {
      root.hidden = true;
      return;
    }
  } catch (error) {}
  var button = root.querySelector('[data-tex-partner-dismiss]');
  if (!button) return;
  button.addEventListener('click', function () {
    root.hidden = true;
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (error) {}
  });
})();
